import actionCreatorFactory from "typescript-fsa";
import { ISurveySubmitResult } from "../reducers/surveyReducer";

const actionCreator = actionCreatorFactory("surveyActions");

export const surveySubmit = actionCreator<ISurveySubmitResult>("SUBMIT_SURVEY");
export const surveySubmitSuccess = actionCreator("SURVEY_SUBMIT_SUCCESS");
export const alreadyAnswered = actionCreator<string>("SURVEY_ALREADY_ANSWERED");